import React, { useEffect, useState } from "react";
import * as navigation from "../../utils/navigation.js";
import axios from "axios";
import { globalVars } from "../../global/GlobalVars.js";

const EmailSettings = (props) => {
  const [settings, setSettings] = useState({
    anlagenname_de: "",
    anlagenname_it: "",
    anlagenname_en: "",
    empfaenger: "",
    server: "",
    port: "",
    username: "",
    password: "",
    sender: "",
    senderName: "",
  });

  //========================================================================
  // Konfiguration der api-Schnittstelle
  const emailUrl =
    window.location.port === "3000"
      ? `http://${window.location.hostname}:${globalVars.httpPort}/email/`
      : `/api/email/`;

  //========================================================================
  // Einstellungen abrufen
  const fetchData = async () => {
    try {
      const response = await axios.get(emailUrl + "getSettings");

      if (response.data) {
        setSettings(response.data);
      }
    } catch (error) {
      console.error("Fehler beim Laden der Settings:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //========================================================================
  //
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(emailUrl + "setSettings", settings);
    } catch (error) {}
  };

  const handleTestMail = (e) => {
    e.preventDefault();
    console.log("Testmail an:", settings.empfaenger);
    // Testmail-Logik hier
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setSettings({
      anlagenname_de: "",
      anlagenname_it: "",
      anlagenname_en: "",
      empfaenger: "",
      server: "",
      port: "",
      username: "",
      password: "",
      sender: "",
      senderName: "",
    });
    navigation.changePage("back");
  };

  const fields = [
    { label: "Anlagenname (DE)", name: "anlagenname_de" },
    { label: "Anlagenname (IT)", name: "anlagenname_it" },
    { label: "Anlagenname (EN)", name: "anlagenname_en" },
    { label: "Empfänger (komma-separiert)", name: "empfaenger" },
    { label: "SMTP Server", name: "server" },
    { label: "Port", name: "port", type: "number" },
    { label: "Benutzername", name: "username" },
    { label: "Passwort", name: "password", type: "password" },
    { label: "Absender E-Mail", name: "sender" },
    { label: "Absendername", name: "senderName" },
  ];

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <div
        style={{
          backgroundColor: "#2c2c2c",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
          margin: "0 auto",
          color: "#fff",
          overflowY: "auto",
        }}
      >
        <form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {fields.map(({ label, name, type = "text" }) => (
            <div
              key={name}
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <label
                htmlFor={name}
                style={{ width: "200px", textAlign: "right", fontSize: "14px" }}
              >
                {label}:
              </label>
              <input
                id={name}
                type={type}
                name={name}
                value={settings[name]}
                onChange={handleChange}
                placeholder={label}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #666",
                  backgroundColor: "#444",
                  color: "#fff",
                  fontSize: "14px",
                }}
              />
            </div>
          ))}

          <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
            <button
              onClick={handleSave}
              style={{
                flex: 1,
                padding: "10px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Speichern
            </button>
            <button
              onClick={handleTestMail}
              style={{
                flex: 1,
                padding: "10px",
                backgroundColor: "#17a2b8",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Testmail
            </button>
            <button
              onClick={handleCancel}
              style={{
                flex: 1,
                padding: "10px",
                backgroundColor: "#6c757d",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailSettings;
